<div class="content-wrapper" *ngIf="audit">
  <div class="audit-title">
    <h3 class="audit-title-title">Audit Report: {{audit.auditTitle}}</h3>
    <h5 class="audit-title-extra">
      <span class="audit-title-status">Audit Status: {{audit.status}}</span>
      <span class="audit-title-duedate">Audit due date: {{audit.dueDate | date:dateFormat}}</span>
    </h5>    
  </div>
</div>